import React, { useState, useMemo, useRef } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import PropTypes from 'prop-types';
import { useSelectedCompany } from '../../../hooks';
import FingoMainView from '../../../components/layout/FingoMainView';
import { GET_SETTLEMENT_OPERATIONS } from '../../../graphql/customers/queries';
import { getClientDocumentSummariesColumns } from '../../../constants/client-document-summaries';
import FingoDataGrid from '../../dataGrids/FingoDataGrid';
import PaperHeader from '../../../components/headers/PaperHeader';
import { DETAILED_DATA_GRID_CLASS_NAME } from '../../../theme/constants/data-grid';
import DateRangePickerButton from '../../buttons/DateRangePickerButton';
import dayjs from '../../../config/dayjs';


const SettlementSummaryTab = ({customCompany}) => {
  const companyId = customCompany !== null ? customCompany : useSelectedCompany()?.id;
  const [selectedOperationIds, setSelectedOperationIds] = useState([]);
  const dataRef = useRef(null);
  const [dates, setDates] = useState({
    dateIssued_Gte: dayjs().subtract(30, 'days'),
    dateIssued_Lte: dayjs(),
  });
  const queryCustomVariables = useMemo(() => ({
    companyId,
    operationCreatedAt_Gte: dates.dateIssued_Gte,
    operationCreatedAt_Lte: dates.dateIssued_Lte,
  }), [companyId, dates.dateIssued_Gte, dates.dateIssued_Lte]);

  return (
    <FingoMainView
      id="settlement-summary-tab"
      query={GET_SETTLEMENT_OPERATIONS}
      queryCustomVariables={queryCustomVariables}
      onCompletedSetRows={(data) => {
        dataRef.current = data;
        return data.getSettlementOperations.edges.map((edge) => edge.node);
      }}
      onCompletedSetLength={(data) => data.getSettlementOperations.totalCount}
      hideReloadButton
      slots={{
        table: FingoDataGrid,
        actions: null,
        header: PaperHeader,
      }}
      slotProps={{
        table: {
          initialOrderBy: '-operationId',
          columns: getClientDocumentSummariesColumns(),
          noRowsMessage: () => <Typography>No hay liquidaciones disponibles</Typography>,
          rowsPerPageOptions: [10, 25, 50, 100],
          className: DETAILED_DATA_GRID_CLASS_NAME,
          onSelectionModelChange: (ids) => {
            setSelectedOperationIds(ids);
          },
          selectionModel: selectedOperationIds,
          outsideBoxProps: {
            sx: {
              '& .MuiDataGrid-footerContainer': {
                borderTop: 'none',
              },
              height: '400px',
              overflow: 'hidden',
              '& > div': {
                height: '100%',
              },
            },
          },
        },
        header: {
          viewTitle: "Selecciona y descarga",
          finderWidth: 250,
          finder: {
            searchPlaceHolder: 'Buscar operación',
          },
          endComponent: 
          <DateRangePickerButton
            dates={dates}
            setDates={setDates}
          />
        }
      }}
    />
  );
};

SettlementSummaryTab.propTypes = {
  customCompany: PropTypes.string.isRequired,
};

export default SettlementSummaryTab;